import React from "react";
import { handleCalendlyForm } from "../utils";
import { CalendarPlus2 } from "lucide-react";

export const ButtonGetQuote = () => {
  return (
    <button className="button-get-quote" onClick={handleCalendlyForm}>
      <CalendarPlus2 className="icon-calendar" size={20} /> Get a Quote
    </button>
  );
};
